(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-tributos-ccaa', {
                parent: 'entity',
                url: '/consortium-tributos-ccaa?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosCcaa'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa.html',
                    controller: 'ConsortiumTributosCcaaController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-tributos-ccaa.new', {
                parent: 'consortium-tributos-ccaa',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa-new.html',
                    controller: 'ConsortiumTributosCcaaNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-tributos-ccaa'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-tributos-ccaa',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-tributos-ccaa.edit', {
                parent: 'consortium-tributos-ccaa',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosCcaa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa-detail.html',
                        controller: 'ConsortiumTributosCcaaDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-tributos-ccaa'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumTributosCcaa', function($stateParams, ConsortiumTributosCcaa) {
                        return ConsortiumTributosCcaa.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-ccaa',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
